import { render, staticRenderFns } from "./SavingPowerReport.vue?vue&type=template&id=74befaf2&scoped=true"
import script from "./SavingPowerReport.vue?vue&type=script&lang=js"
export * from "./SavingPowerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74befaf2",
  null
  
)

export default component.exports